const footer = document.querySelector(".footer");

if (footer) {
    const footerVar = getComputedStyle(document.documentElement).getPropertyValue('--footer');

    function footerResize() {
        const footerHeight = footer.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--footer', footerHeight + "px");
    }

    window.onresize = footerResize;

    footerResize();
}